import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { legacyUnsubscribeBridgeUrl } from "../Services/PublicEmailSubscriptions";

/**
 * Public bridge for classic unsubscribe URLs (email-subscription.asp, etc.).
 * Sends the browser to the API legacy endpoint, which applies one-click (if any)
 * and 302s to /email-subscriptions?token=...
 */
export default function LegacyUnsubscribeBridge({
  defaultType,
}: {
  defaultType?: string;
}): React.ReactElement {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (defaultType && !params.get("type")) {
      params.set("type", defaultType);
    }
    const qs = params.toString();
    window.location.replace(
      legacyUnsubscribeBridgeUrl(qs ? `?${qs}` : "")
    );
  }, [location.search, defaultType]);

  return (
    <main
      className="min-h-[40vh] flex items-center justify-center p-6"
      style={{ background: "#f4f4f4" }}
    >
      <p className="text-gray-600 text-sm">Processing your request…</p>
    </main>
  );
}
